export enum CareBeginType {
  OPEN = 'open',

  DATE = 'date',
}
